<template>
  <div>
    <h2>
      Ręczne dodawanie
    </h2>
    <v-alert v-if="message" :type="message.type" dismissible dense class="mt-2">
      {{ message.value }}
    </v-alert>
    <v-data-table
        :headers="headers"
        :items="items"
        disable-pagination
        hide-default-footer
    >
      <template v-slot:item.name="props">
        <v-text-field v-model="props.item.name"
                      placeholder="Nazwa firmy"
                      counter="254"
        ></v-text-field>
      </template>
      <template v-slot:item.www="props">
        <v-text-field v-model="props.item.www"
                      placeholder="Adres URL"
                      counter="254"
        ></v-text-field>
      </template>
      <template v-slot:item.email="props">
        <v-text-field v-model="props.item.email"
                      placeholder="Adres e-mail"
                      counter="254"
        ></v-text-field>
      </template>
      <template v-slot:item.phone="props">
        <v-text-field v-model="props.item.phone"
                      placeholder="Numer telefonu"
                      counter="20"
        ></v-text-field>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            @click="deleteRow(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-layout row justify-center>
      <v-btn class="ma-2"
             @click="addNewRow()"
      >
        Dodaj nowy wiersz
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  props: ['saleOfferId'],
  data() {
    return {
      loading: false,
      message: null,
      selected: [],
      headers: [
        {text: 'Nazwa', value: 'name'},
        {text: 'Www', value: 'www'},
        {text: 'E-mail', value: 'email'},
        {text: 'Telefon', value: 'phone'},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      items: [],
      defaultItems: [
        {id: 0, www: '', name: '', email: '', phone: ''},
      ],
    }
  },
  created() {
    this.initialize();
  },
  mounted() {
    const self = this;

    this.$root.$on('getManuallyAddedCompanies', (store) => {
      store.companies = self.getCompanies(store.allowEmpty || false);
    });

    this.$root.$on('sendToManuallyAddedCompanies', async () => {
      await self.send();
    });
  },
  methods: {
    initialize() {
      // Deep copy.
      const items = JSON.parse(JSON.stringify(this.defaultItems));

      items.map(item => {
        return item;
      });

      this.items = items;
    },
    addNewRow() {
      const length = this.items.length;
      const lastItem = this.items[length - 1];
      let newItem = JSON.parse(JSON.stringify(this.defaultItems[0]));

      newItem.id = (lastItem ? lastItem.id : newItem.id) + 1;

      this.items.push(newItem);
    },
    deleteRow(item) {
      const index = this.items.indexOf(item);
      confirm('Czy na pewno chcesz usunąć ten wiersz?') && this.items.splice(index, 1);
    },
    getCompanies(allowEmpty = false) {
      const self = this;

      // Deep copy.
      let companies = JSON.parse(JSON.stringify(this.items));

      companies = companies.filter(item => {
        if (allowEmpty && !item.name && !item.email && !item.phone) {
          return false;
        }

        if (!item.name) {
          self.message = {
            type: 'error',
            value: 'Conajmniej jeden wiersz nie ma nazwy firmy lub jest niepoprawna.'
          };

          return false; // Skip this element.
        }

        if (!item.email) {
          self.message = {
            type: 'error',
            value: 'Conajmniej jeden wiersz nie ma adresu e-mail lub jest niepoprawny.'
          };

          return false; // Skip this element.
        }

        return true;
      }).map(item => {
        delete item.id; // Remove this property.

        return item;
      });

      return companies;
    },
    async send() {
        this.message = null;
        this.loading = true;

        try {
            const companies = this.getCompanies();

            if (!companies || !companies.length) {
              this.loading = false;

              return;
            }

            await api.post('/api/sale-offers/send-to-potentially-interested', {
                saleOfferId: this.saleOfferId,
                manuallyAdded: this.getCompanies(),
            });

            this.message = {
                type: 'success',
                value: 'Oferta została wysłana.',
            };

            this.$emit('sent');
        } catch(e) {
            this.loading = false;
            this.message = {
                type: 'error',
                value: 'Nie udało się wysłać oferty.',
            }
        }

        this.loading = false;
    },
  }
}
</script>